import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import {
  airplaneIcon,
  buildingIcon,
  busIcon,
  cutleryIcon,
  educationIcon,
  ferryIcon,
  gasStationIcon,
  glassIcon,
  healthIcon,
  outdoorScreenIcon,
  shoppingBagIcon,
  spaIcon,
  storeIcon,
  subwayIcon,
  taxiExteriorIcon,
  taxiIcon,
  ticketIcon,
  totemIcon,
  trainIcon,
  weightsIcon,
} from "../icons/pines-map";
import Colors from "../themes/Colors";
import { shiftHsl } from "../services/graphicsService";

// Venue categories controller. Single place to configure how screens are
// grouped by category on the map, legend, screen list and screen detail.
// The legend follows the array order, with "Others" last.
//
// - rootIds: OpenOOH root ids (open_ooh_venue_type_id_parent) grouped in the category.
// - color: shared by the category and everything inside it. Derived from the
//   brand's Colors.primary, so every white label gets its own palette. The
//   shifts are tuned so the Latinad primary (#3996F3) gives the design palette.
// - icon: default icon of the category (any venue type without its own icon).
// - subtypeIcons (optional): icon per OpenOOH id (root, level 2 or 3). The most
//   specific id of the screen's path wins, so a level 3 id without its own entry
//   inherits its level 2 icon, and that one its root icon.
//
// Icons accept any FontAwesome-shaped definition ({ prefix, iconName, icon: [w, h, [], "", svgPath] }),
// like the designed pin icons in src/icons/pines-map.
export const VENUE_CATEGORIES = [
  {
    // Transit
    labelKey: "subtype_1",
    rootIds: [1],
    color: Colors.primary, // Latinad #3996F3
    icon: busIcon,
    subtypeIcons: {
      101: airplaneIcon, // Airport
      102: busIcon, // Bus (10202 Terminal inherits it)
      103: taxiIcon, // Taxi (interior)
      104: taxiExteriorIcon, // Taxi (exterior)
      105: subwayIcon, // Subway
      106: trainIcon, // Train station
      107: ferryIcon, // Ferry
    },
  },
  {
    // Retail
    labelKey: "subtype_2",
    rootIds: [2],
    // Darker and bluer (Latinad #2457D6)
    color: shiftHsl(Colors.primary, { hue: 12.809, saturation: 0.804, lightness: 0.833 }),
    icon: storeIcon,
    subtypeIcons: {
      201: gasStationIcon, // Fueling station
      205: shoppingBagIcon, // Mall
    },
  },
  {
    // Outdoor
    labelKey: "subtype_3",
    rootIds: [3],
    // Deep navy (Latinad #102A63)
    color: shiftHsl(Colors.primary, { hue: 11.205, saturation: 0.815, lightness: 0.383 }),
    icon: outdoorScreenIcon,
    subtypeIcons: {
      301: outdoorScreenIcon, // Billboards
      302: totemIcon, // Urban panels (totems)
      303: totemIcon, // Bus shelters (totems)
    },
  },
  {
    // Education
    labelKey: "subtype_6",
    rootIds: [6],
    // Towards green, cyan (Latinad #18C6D9)
    color: shiftHsl(Colors.primary, { hue: -24.093, saturation: 0.904, lightness: 0.803 }),
    icon: educationIcon,
  },
];

// "Others": groups roots 4, 5, 7, 8, 9, 10 and 11, plus screens without
// category or with an unknown root id.
export const OTHER_VENUE_CATEGORY = {
  labelKey: "venue_category_other",
  // Desaturated bluish gray (Latinad #8A94A6)
  color: shiftHsl(Colors.primary, { hue: 8.571, saturation: 0.153, lightness: 1.013 }),
  icon: faEllipsisH,
  subtypeIcons: {
    401: weightsIcon, // Gyms
    402: spaIcon, // Salons
    5: healthIcon, // Point of Care
    7: buildingIcon, // Office Buildings
    8: ticketIcon, // Leisure
    804: glassIcon, // Bars
    805: cutleryIcon, // Casual dining
    810: cutleryIcon, // High-end dining
    9: buildingIcon, // Government
    10: buildingIcon, // Financial
    11: buildingIcon, // Residential
  },
};
